var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      key: _vm.upid,
      class: _vm.bemBlockMod({
        modal: _vm.context === _vm.CONTEXT_MODAL
      }),
      attrs: {
        id: "vueproduct",
        "data-get-content-asset": _vm.getContentAssetUrl
      }
    },
    [
      _vm.context === _vm.CONTEXT_ROUTER_VIEW &&
      !_vm.shouldHideExternalBackButton
        ? _c("BaseBackButton")
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "product-detail product-wrapper product-detail-vue",
          attrs: { "data-context": _vm.context, "data-pid": _vm.product.id }
        },
        [
          _c("BaseProductDataForSfra", { attrs: { product: _vm.product } }),
          _vm._v(" "),
          _c("meta", { attrs: { itemprop: "sku", content: _vm.product.id } }),
          _vm._v(" "),
          _c("meta", { attrs: { itemprop: "mpn", content: _vm.product.id } }),
          _vm._v(" "),
          _vm.product.longDescription
            ? _c("meta", {
                attrs: {
                  itemprop: "description",
                  content: _vm.product.longDescription
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("meta", { attrs: { itemprop: "brand", content: "BIMBA Y LOLA" } }),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "imagesContainer",
              class: _vm.bemElement(
                _vm.isBreakpointDesktop
                  ? "images-container"
                  : "carousel-container"
              )
            },
            [
              !_vm.isBreakpointDesktop && _vm.showVirtualTryOnTag
                ? _c("BaseTag", {
                    staticClass: "iframe-tag",
                    attrs: {
                      type: "detail",
                      subtype: "secondary",
                      text: _vm.$msg("tag.iframe", "product"),
                      "is-custom": true
                    },
                    nativeOn: {
                      click: function($event) {
                        return _vm.openIframeModal($event)
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.product.assignedToSiteCatalog
                ? _c("BaseProductColorSwatches", {
                    class: _vm.bemElement("swatches"),
                    attrs: {
                      bem: "the-product-details-swatches",
                      product: _vm.product,
                      "show-current": true,
                      "product-detail": true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.isBreakpointDesktop
                ? _c("BaseProductActionableLink", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.product.bylActionableLink,
                        expression: "product.bylActionableLink"
                      }
                    ],
                    class: _vm.bemElement("actionable-link"),
                    attrs: {
                      bem: "the-product-details-actionable-link",
                      product: _vm.product
                    },
                    on: {
                      "actionable-link:clicked": function($event) {
                        _vm.baseActionableLinkDisplayOpen = true
                      }
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              !_vm.hasImages
                ? _c("div", { class: _vm.bemElement("pre-placeholder") }, [
                    _c("span", { class: [_vm.bemElement("pic"), "img"] })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.productImageSets, function(imageSet, imageIndex) {
                return _c("BaseImage", {
                  key: imageIndex,
                  class: _vm.bemElement("pic"),
                  attrs: {
                    src: _vm.getDefaultImageUrlFromProductImageSet(imageSet),
                    alt: _vm.getDefaultImageAltFromProductImageSet(imageSet),
                    loading:
                      imageIndex < 1 || _vm.areCriticalImagesLoaded
                        ? "eager"
                        : null,
                    placeholder: _vm.getPlaceholderImageUrlFromProductImageSet(
                      imageSet
                    ),
                    sizes: _vm.imageAttributeSizes.PDP_GALLERY,
                    srcset: _vm.getSrcsetFromProductImageSet(imageSet)
                  },
                  on: {
                    "image-click": function(event) {
                      return _vm.handleProductImageClick(event, imageIndex)
                    },
                    load: function($event) {
                      return _vm.handleImageLoad(imageIndex)
                    }
                  }
                })
              }),
              _vm._v(" "),
              _vm.$windowWidth < 575 && _vm.hasImages
                ? _c("BaseCarousel", {
                    class: _vm.bemElement("carousel"),
                    attrs: { items: _vm.productImageSets },
                    on: {
                      "carousel-click": function(event, currentIndex) {
                        return _vm.handleProductImageClick(event, currentIndex)
                      }
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(slotProps) {
                            return [
                              _c("BaseImage", {
                                ref: "carouselItem" + slotProps.index,
                                class: slotProps.classname,
                                attrs: {
                                  src: _vm.getDefaultImageUrlFromProductImageSet(
                                    slotProps.item
                                  ),
                                  alt: _vm.getDefaultImageAltFromProductImageSet(
                                    slotProps.item
                                  ),
                                  "image-classes": _vm.bemElement("image"),
                                  loading:
                                    slotProps.index === 0 ||
                                    _vm.areCriticalImagesLoaded
                                      ? "eager"
                                      : null,
                                  placeholder: _vm.getPlaceholderImageUrlFromProductImageSet(
                                    slotProps.item
                                  ),
                                  sizes: _vm.imageAttributeSizes.PDP_GALLERY,
                                  srcset: _vm.getSrcsetFromProductImageSet(
                                    slotProps.item
                                  )
                                },
                                on: {
                                  load: function($event) {
                                    return _vm.handleImageLoad(slotProps.index)
                                  }
                                }
                              })
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2875319704
                    )
                  })
                : _vm._e()
            ],
            2
          ),
          _vm._v(" "),
          _c("div", { class: _vm.bemElement("text-container") }, [
            _c(
              "div",
              {
                ref: "infoContainer",
                class: _vm.bemElement("sticky-container")
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "interaction--loading-content",
                    class: { "interaction-active": !_vm.loading },
                    attrs: {
                      "data-interaction": "interaction--loading-content"
                    }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "loading-content" },
                      [_c("BaseSpinner", { attrs: { small: "", grey: "" } })],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "loaded-content" },
                      [
                        _c(
                          "div",
                          { class: _vm.bemElement("sticky-child-container") },
                          [
                            _vm.isCustomTag
                              ? _c(
                                  "p",
                                  { class: _vm.bemElement("tag", "custom") },
                                  [
                                    _c("BaseTag", {
                                      attrs: {
                                        type: "detail",
                                        subtype: "primary",
                                        text: _vm.customTag.name,
                                        "text-color": _vm.customTag.color,
                                        "is-custom": _vm.isCustomTag
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { class: _vm.bemElement("title-wrapper") },
                              [
                                _c(
                                  "h1",
                                  {
                                    class: _vm.bemElement("title"),
                                    attrs: { itemprop: "name" }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(_vm.product.productName) +
                                        "\n                "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.isWishlistEnabled &&
                                _vm.product.assignedToSiteCatalog &&
                                !_vm.isCustomizable
                                  ? _c("BaseWishlistHeart", {
                                      class: _vm.bemElement("add-to-wishlist"),
                                      attrs: {
                                        "product-id": _vm.product.id,
                                        product: _vm.product,
                                        "is-pdp-context": true
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.product.assignedToSiteCatalog
                              ? _c("BasePrice", {
                                  attrs: {
                                    bem: "the-product-details-price",
                                    product: _vm.product,
                                    "show-previous-price-msg": true,
                                    "show-previous-price-msg-tooltip": true
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("BaseSlotMessage", {
                          class: _vm.bemElement("message"),
                          attrs: { "slot-id": "pdp-message" }
                        }),
                        _vm._v(" "),
                        _c("p", {
                          class: _vm.bemElement("description"),
                          domProps: {
                            innerHTML: _vm._s(_vm.product.longDescription)
                          }
                        }),
                        _vm._v(" "),
                        _c("TheProductDetailsAdditionalInfo", {
                          class: _vm.bemElement("additional-info"),
                          attrs: { product: _vm.product }
                        }),
                        _vm._v(" "),
                        _vm.isBreakpointDesktop && _vm.showVirtualTryOnTag
                          ? _c("BaseTag", {
                              staticClass: "iframe-tag",
                              attrs: {
                                type: "detail",
                                subtype: "secondary",
                                text: _vm.$msg("tag.iframe", "product"),
                                "is-custom": true
                              },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.openIframeModal($event)
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isBreakpointDesktop
                          ? _c("BaseProductActionableLink", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.product.bylActionableLink,
                                  expression: "product.bylActionableLink"
                                }
                              ],
                              class: _vm.bemElement("actionable-link"),
                              attrs: {
                                bem: "the-product-details-actionable-link",
                                product: _vm.product
                              },
                              on: {
                                "actionable-link:clicked": function($event) {
                                  _vm.baseActionableLinkDisplayOpen = true
                                }
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isBreakpointDesktop &&
                        _vm.product.assignedToSiteCatalog
                          ? _c("TheProductDetailsSizeSelector", {
                              ref: "desktopSizeSelector",
                              class: _vm.bemElement("sizes", {
                                "no-stock": !_vm.product.available
                              }),
                              attrs: {
                                product: _vm.product,
                                "show-size-conversion": true
                              },
                              on: { "size:change": _vm.handleSizeChange }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isMarketWithoutSale &&
                        _vm.isStockAlertEnabled &&
                        _vm.isStockAlertAvailable &&
                        _vm.product.assignedToSiteCatalog
                          ? _c(
                              "BaseModalCTA",
                              {
                                class: [_vm.bemElement("actions")],
                                attrs: {
                                  "show-modal-close": true,
                                  "hide-button-on-open": true,
                                  "button-text": _vm.$msg(
                                    "button.stockalert",
                                    "product"
                                  ),
                                  "is-open": _vm.isStockAlertModalOpen,
                                  "no-padding": true
                                },
                                on: {
                                  "modal:change-state":
                                    _vm.handleStockAlertModalState,
                                  "modal:close-all": _vm.handleModalClose
                                }
                              },
                              [
                                _c("TheProductDetailsStockAlert", {
                                  attrs: {
                                    product: _vm.product,
                                    "is-disabled":
                                      _vm.isBreakpointDesktop &&
                                      !_vm.selectedSize,
                                    "stock-alert-visible":
                                      _vm.isStockAlertModalOpen,
                                    "stock-alert-size": _vm.selectedSize || {}
                                  },
                                  on: {
                                    "stock-alert:hide":
                                      _vm.handleStockAlertModalState
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isStockAlertEnabled &&
                        !_vm.hasSomeSelectableSize() &&
                        _vm.product.assignedToSiteCatalog
                          ? _c("p", { class: _vm.bemElement("sold-out") }, [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$msg(
                                      "tag.coming_unavailable",
                                      "product"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isCustomizable &&
                        !_vm.isStockAlertAvailable &&
                        !_vm.isAppExclusive &&
                        _vm.product.assignedToSiteCatalog &&
                        !_vm.isMarketWithoutSale
                          ? _c(
                              "div",
                              {
                                class: [
                                  _vm.bemElement("customize", ["desktop"]),
                                  _vm.bemElement("actions")
                                ]
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    class: [
                                      _vm.bemElement("customize-btn", [
                                        "desktop"
                                      ]),
                                      "btn",
                                      "btn-primary",
                                      "btn-big"
                                    ],
                                    attrs: {
                                      "data-pid": _vm.product.id,
                                      "data-toggle": "modal",
                                      "data-target": ""
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.willOpenCustomizeModal = !_vm.willOpenCustomizeModal
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "default-content" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$msg(
                                                "button.customize",
                                                "product"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isButtonDesktopAvailable
                          ? _c(
                              "div",
                              {
                                class: [
                                  _vm.bemElement("add-to-cart"),
                                  _vm.bemElement("actions"),
                                  "cart-and-ipay"
                                ]
                              },
                              [
                                _c("input", {
                                  staticClass: "add-to-cart-url",
                                  attrs: { type: "hidden" },
                                  domProps: { value: _vm.addToCartUrl }
                                }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    class: [
                                      _vm.bemElement("add-to-cart-btn", [
                                        "desktop"
                                      ]),
                                      "add-to-cart",
                                      "btn",
                                      "btn-primary",
                                      "btn-big",
                                      "interaction--add-to-bag"
                                    ],
                                    attrs: {
                                      "data-pid": _vm.product.id,
                                      "data-toggle": "modal",
                                      "data-target": "#chooseBonusProductModal",
                                      "data-interaction":
                                        "interaction--add-to-bag",
                                      "data-interaction-state":
                                        _vm.initialStateAddToBag
                                    }
                                  },
                                  [
                                    _c("BaseSpinner", { attrs: { small: "" } }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "default-content" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$msg(
                                                "button.addtocart",
                                                "product"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "swap-content" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$msg(
                                                "text.alert.addedtobasket",
                                                "product"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  {
                                    class: _vm.bemElement("add-to-cart-error")
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$msg(
                                            "error.size.unselected",
                                            "product"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isMarketWithoutSale &&
                        _vm.product.assignedToSiteCatalog
                          ? _c(
                              "a",
                              {
                                class: [
                                  _vm.bemElement("find-stores"),
                                  _vm.bemElement("actions"),
                                  "btn",
                                  {
                                    "btn--cta": _vm.isBreakpointMobile,
                                    "btn-primary btn-big": !_vm.isBreakpointMobile
                                  }
                                ],
                                attrs: { href: _vm.findStoresUrl }
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$msg("button.find.store", "product")
                                    ) +
                                    "\n            "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isMarketWithoutSale &&
                        _vm.availabilityMessage.length > 0 &&
                        _vm.product.assignedToSiteCatalog
                          ? _c("p", {
                              class: _vm.bemElement("informative-claim"),
                              domProps: {
                                innerHTML: _vm._s(_vm.availabilityMessage)
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isAppExclusive && _vm.product.assignedToSiteCatalog
                          ? _c(
                              "div",
                              {
                                class: [
                                  _vm.bemElement("app-exclusive"),
                                  _vm.bemElement("actions"),
                                  "app-exclusive-block"
                                ]
                              },
                              [
                                _c(
                                  "p",
                                  {
                                    staticClass:
                                      "app-exclusive-block__description-text"
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$msg(
                                            "appexclusive.description",
                                            "product"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    staticClass: "app-exclusive-block__link",
                                    attrs: { href: _vm.appsLandingUrl }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$msg(
                                            "appexclusive.link",
                                            "product"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.productAddedToCart &&
                        _vm.isBreakpointMobile &&
                        _vm.product.assignedToSiteCatalog
                          ? _c(
                              "BaseModalCTA",
                              {
                                class: _vm.bemElement("actions"),
                                attrs: { "is-open": true, "no-padding": true }
                              },
                              [
                                _c("p", { class: [_vm.bemElement("text")] }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.addedMessage) +
                                      "\n              "
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    class: [
                                      _vm.bemElement("btn-modal", "btn-link"),
                                      "btn",
                                      "btn--cta"
                                    ],
                                    attrs: { href: _vm.cartShowUrl }
                                  },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm.$msg(
                                            "button.productcard",
                                            "product"
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isButtonMobileAvailable &&
                        (_vm.isStockAlertEnabled ||
                          _vm.hasSomeSelectableSize()) &&
                        _vm.product.assignedToSiteCatalog
                          ? _c(
                              "button",
                              {
                                class: [
                                  _vm.bemElement("add-to-cart-btn", "mobile"),
                                  _vm.bemElement("actions"),
                                  "add-to-cart-mobile",
                                  "btn",
                                  "btn--cta",
                                  "interaction--add-to-bag-mobile"
                                ],
                                attrs: {
                                  "data-pid": _vm.product.id,
                                  "data-size-type": _vm.mobileTypeBySizeButton,
                                  "data-attr-url": _vm.hasUniqueSelectableSize()
                                    ? _vm.sizes[0].url
                                    : null,
                                  "data-toggle": "modal",
                                  "data-target": "#chooseBonusProductModal",
                                  "data-interaction":
                                    "interaction--add-to-bag-mobile",
                                  "data-interaction-state":
                                    _vm.initialStateAddToBagMobile
                                }
                              },
                              [
                                _c("BaseSpinner", {
                                  attrs: { small: "", white: "" }
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "default-content" },
                                  [
                                    _vm.hasUniqueSelectableSize()
                                      ? _c(
                                          "span",
                                          { staticClass: "one-size" },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  _vm.hasNoStock
                                                    ? _vm.$msg(
                                                        "button.stockalert",
                                                        "product"
                                                      )
                                                    : _vm.$msg(
                                                        "button.addtocart",
                                                        "product"
                                                      )
                                                ) +
                                                "\n                "
                                            )
                                          ]
                                        )
                                      : _c(
                                          "BaseModalCTA",
                                          {
                                            staticClass: "multiple-sizes",
                                            attrs: {
                                              "show-modal-close": true,
                                              "button-text": _vm.$msg(
                                                "button.sizeselect",
                                                "product"
                                              ),
                                              "is-open":
                                                _vm.isSizeSelectorMobileShown
                                            },
                                            on: {
                                              "modal:change-state":
                                                _vm.handleSizeSelectorMobileState,
                                              "modal:close-all":
                                                _vm.handleModalClose
                                            }
                                          },
                                          [
                                            _c(
                                              "TheProductDetailsSizeSelector",
                                              {
                                                ref: "mobileSizeSelector",
                                                attrs: {
                                                  product: _vm.product,
                                                  "show-size-conversion": true
                                                },
                                                on: {
                                                  "size:change":
                                                    _vm.handleSizeChange
                                                }
                                              }
                                            )
                                          ],
                                          1
                                        )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", { staticClass: "swap-content" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.addedMessage) +
                                      "\n              "
                                  )
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isCustomizable &&
                        !_vm.isStockAlertAvailable &&
                        !_vm.isAppExclusive &&
                        _vm.product.assignedToSiteCatalog &&
                        !_vm.isMarketWithoutSale
                          ? _c(
                              "div",
                              {
                                class: [
                                  _vm.bemElement("customize", ["mobile"]),
                                  _vm.bemElement("actions")
                                ]
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    class: [
                                      _vm.bemElement("actions"),
                                      "btn",
                                      "btn--cta",
                                      "btn-big",
                                      "customize-btn--mobile"
                                    ],
                                    attrs: {
                                      "data-pid": _vm.product.id,
                                      "data-toggle": "modal",
                                      "data-target": ""
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.willOpenCustomizeModal = !_vm.willOpenCustomizeModal
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "default-content" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$msg(
                                                "button.customize",
                                                "product"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isMarketWithoutSale &&
                        !_vm.isStockAlertAvailable &&
                        _vm.isBreakpointMobile &&
                        _vm.isAppExclusive &&
                        _vm.product.assignedToSiteCatalog
                          ? _c(
                              "button",
                              {
                                class: [
                                  _vm.bemElement("app-exclusive-btn", "mobile"),
                                  _vm.bemElement("actions"),
                                  "btn",
                                  "btn--cta"
                                ]
                              },
                              [
                                _c(
                                  "BaseModalCTA",
                                  {
                                    staticClass: "app-exclusive-block",
                                    attrs: {
                                      "is-open": false,
                                      "show-modal-close": true,
                                      "button-text": _vm.isAppExclusiveModalOpen
                                        ? _vm.$msg(
                                            "appexclusive.link",
                                            "product"
                                          )
                                        : _vm.$msg(
                                            "button.appexclusive",
                                            "product"
                                          )
                                    },
                                    on: {
                                      "modal:change-state":
                                        _vm.handleAppExclusiveModalState
                                    }
                                  },
                                  [
                                    _c(
                                      "p",
                                      {
                                        staticClass:
                                          "app-exclusive-block__description-text"
                                      },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(
                                              _vm.$msg(
                                                "appexclusive.description",
                                                "product"
                                              )
                                            ) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.product.assignedToSiteCatalog
                  ? _c(
                      "div",
                      {
                        class: [
                          _vm.bemElement("accordion-container"),
                          "expand-elements-wrapper"
                        ]
                      },
                      [
                        _c(
                          "button",
                          {
                            class: [
                              _vm.bemElement("size-guide-btn"),
                              "btn",
                              "btn--primary"
                            ],
                            attrs: {
                              "data-interaction": "modal",
                              "data-modal-type": "size-guide",
                              "data-modal-close": "true",
                              "data-modal-content-url": _vm.helpGetSizeGuideUrl
                            },
                            on: { click: _vm.handleSizeGuideButtonClick }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$msg("link.size_guide", "product")) +
                                "\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "BaseAccordion",
                          {
                            attrs: {
                              title: _vm.$msg("details.title", "product"),
                              "group-name": _vm.groupNameToToggle
                            }
                          },
                          [
                            _c("ul", [
                              _c("li", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s("Ref: " + _vm.pidWithoutSize) +
                                    "\n              "
                                )
                              ]),
                              _vm._v(" "),
                              !!_vm.product.bylDetailsAdditional
                                ? _c("li", {
                                    class: _vm.bemElement("details-additional"),
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.product.bylDetailsAdditional
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !!_vm.product.bylCompositionText
                                ? _c("li", {
                                    class: _vm.bemElement("composition"),
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.product.bylCompositionText
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              !!_vm.product.bylWashing
                                ? _c(
                                    "li",
                                    { class: _vm.bemElement("details-list") },
                                    _vm._l(_vm.product.bylWashing, function(
                                      washingText,
                                      washingIndex
                                    ) {
                                      return _c(
                                        "span",
                                        {
                                          key: washingIndex,
                                          class: _vm.bemElement("details-item")
                                        },
                                        [_vm._v(_vm._s(washingText))]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.product.bylMadeIn
                                ? _c(
                                    "li",
                                    {
                                      class: [
                                        _vm.bemElement("made-in"),
                                        _vm.bemElement("text-line")
                                      ]
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm.$msg(
                                              "label.madein",
                                              "product"
                                            ) + " "
                                          ) +
                                          "\n                "
                                      ),
                                      _c(
                                        "span",
                                        {
                                          class: _vm.bemElement(
                                            "made-in-country"
                                          )
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(_vm.product.bylMadeIn) +
                                              "\n                "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        !_vm.isMarketWithoutSale
                          ? _c(
                              "BaseAccordion",
                              {
                                class: [
                                  "delivery-and-returns",
                                  _vm.bemElement("delivery-and-returns")
                                ],
                                attrs: {
                                  title: _vm.$msg(
                                    "deliveryreturns.title",
                                    "product"
                                  ),
                                  "group-name": _vm.groupNameToToggle,
                                  "accordion-id": "deliveryAndReturns"
                                }
                              },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$msg(
                                        "msg.pdp.delivery.returns.info",
                                        "product"
                                      )
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isMarketWithoutSale
                          ? _c(
                              "BaseAccordion",
                              {
                                class: [
                                  "payment-methods",
                                  _vm.bemElement("payment-methods")
                                ],
                                attrs: {
                                  title: _vm.$msg(
                                    "paymentMethods.title",
                                    "product"
                                  ),
                                  "group-name": _vm.groupNameToToggle,
                                  "accordion-id": "paymentMethods"
                                }
                              },
                              [
                                _c("div", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$msg(
                                        "msg.pdp.payment.methods.info",
                                        "product"
                                      )
                                    )
                                  }
                                })
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isInStoreStockEnabled
                          ? _c(
                              "button",
                              {
                                class: [
                                  _vm.bemElement("store-stock-btn"),
                                  "btn",
                                  "btn--primary"
                                ],
                                on: {
                                  click: function($event) {
                                    _vm.willOpenInStoreStockModal = !_vm.willOpenInStoreStockModal
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$msg(
                                        "instorestock.title",
                                        "inStoreStock"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isChatButtonPDPEnabled
                          ? _c(
                              "button",
                              {
                                ref: "chatButton",
                                class: [
                                  _vm.bemElement("chat-button"),
                                  "chat-button",
                                  "btn",
                                  "btn--primary"
                                ],
                                on: { click: _vm.handleChatButtonClick }
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$msg("button.chat", "product")) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.webShareApiSupported && _vm.isBreakpointMobile
                          ? _c("BaseShareProductButton", {
                              class: [
                                _vm.bemElement("share-btn"),
                                "btn",
                                "btn--primary"
                              ],
                              attrs: { "product-name": _vm.product.productName }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _vm.enoughCompleteThelookProducts && _vm.product.assignedToSiteCatalog
        ? _c("BaseProductSlider", {
            class: _vm.bemElement("complete-the-look"),
            attrs: {
              heading: _vm.$msg("completethelook.title", "product"),
              products: _vm.product.bylCompleteTheLook.slice(0, 10),
              "tile-context": _vm.pdpSlider
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.recommendedProducts.length > 0 && _vm.product.assignedToSiteCatalog
        ? _c("BaseProductSlider", {
            class: _vm.bemElement("recommendations"),
            attrs: {
              heading: _vm.recommendationsHeading,
              products: _vm.recommendedProducts,
              "wrap-items": true,
              "tile-context": _vm.pdpRecommendedSlider,
              "hide-product-names": _vm.recommendationsDisplay.hideProductNames,
              "hide-prices": _vm.recommendationsDisplay.hidePrices,
              "hide-discount": _vm.recommendationsDisplay.hideDiscount,
              "hide-tags": _vm.recommendationsDisplay.hideTags,
              "is-recommendation-from-einstein":
                _vm.isRecommendationFromEinstein,
              "recommender-name": _vm.recommendationsRecommenderName
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("TheProductDetailsZoom", {
        class: {
          "is-visible": _vm.isZoomOpen
        },
        attrs: {
          "is-visible": _vm.isZoomOpen,
          images: _vm.productImageSets,
          loading: _vm.areGalleryImagesLoaded ? "eager" : null,
          "zoom-requirements": _vm.zoomRequirements
        },
        on: {
          "close-click": function($event) {
            return _vm.closeZoom(true)
          }
        }
      }),
      _vm._v(" "),
      _vm.willOpenInStoreStockModal
        ? _c("TheInStoreStockModal", {
            attrs: { product: _vm.product },
            on: {
              "in-store-stock-modal-closed": function($event) {
                _vm.willOpenInStoreStockModal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.iframeUrl
        ? _c(
            "BaseModal",
            {
              attrs: {
                "is-open": _vm.showIframeModal,
                "modal-modifier": "ar-try-on",
                "show-backdrop": true,
                "close-on-backdrop-interaction": true
              },
              on: {
                closed: function($event) {
                  _vm.showIframeModal = false
                }
              }
            },
            [
              _c("iframe", {
                attrs: {
                  allow: "camera; web-share",
                  width: "100%",
                  height: "100%",
                  frameBorder: "0",
                  src: _vm.iframeUrl
                }
              })
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.willOpenCustomizeModal
        ? _c("TheProductDetailsCustomizationModal", {
            attrs: {
              product: _vm.product,
              "add-to-cart-url": _vm.addToCartUrl,
              "add-to-cart-url-mobile": _vm.sizes[0].url
            },
            on: {
              "customize-modal-closed": function($event) {
                _vm.willOpenCustomizeModal = false
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.product.bylActionableLink
        ? _c("BaseActionableLinkDisplay", {
            attrs: {
              "is-open": _vm.baseActionableLinkDisplayOpen,
              product: _vm.product,
              "modal-modifier": "pdp"
            },
            on: {
              closed: function($event) {
                _vm.baseActionableLinkDisplayOpen = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }